import React, { memo } from "react";

const BookingCards = ({ cardType, totalCards }) => {
	if (totalCards <= 0) return null;

	const isRed = cardType === "RED_CARD";
	const isYellow = cardType === "YELLOW_CARD";
	if (!isRed && !isYellow) return null;

	const label = `${totalCards} ${isRed ? "red" : "yellow"} card${totalCards > 1 ? "s" : ""}`;

	return (
		<span
			className={`booking-card ${isRed ? "booking-card--red" : "booking-card--yellow"}`}
			role="img"
			aria-label={label}
		>
			{totalCards}
		</span>
	);
};

export default memo(BookingCards);
